<template>
  <div class="page-container">
    <div class="main">
      <page :url="url" :form="form" @reset="reset" ref="pageRef">
        <template slot="tableSearch">


          <el-form-item :label="$t('text.customerCert')">
            <el-input
                v-model="form.customerCert"
                :placeholder="$t('message.inputCustomerCert')"
                style="width: 260px"
                maxlength="50"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('text.operator')">
            <el-input
                v-model="form.operator"
                :placeholder="$t('message.inputOperator')"
                style="width: 260px"
                maxlength="50"
            ></el-input>
          </el-form-item>


        </template>
        <template slot="buttonArea">
          <el-button
              v-if="ROLE_TYPE.isManager()"
              type="primary"
              size="mini"
              plain
              @click="handleShowAddBlackList">
            {{ $t('text.blackListCreate') }}
          </el-button>
          <el-button
              v-if="ROLE_TYPE.isManager()"
              type="primary"
              size="mini"
              plain
              @click="handleShowBlackListRiskConfig">
            {{ $t('text.blackRiskControlParameterSettings') }}
          </el-button>
        </template>
        <template slot="tableColumn">
          <el-table-column
              prop="customerCert"
              :label="$t('text.walletOrCardNumber')"
              align="center"
              width="200"/>

          <el-table-column
              prop="payType"
              width="80px"
              :label="$t('text.channelType')"
              align="center">
            <template slot-scope="{ row }">
              <el-tag
                size="small"
                :type="row.payType === '110' ? 'primary' : (row.payType === '120' ? 'warning' : 'info')">
                <div>
                  {{ row.payType === '110' ? $t('text.collection') : (row.payType === '120' ? $t('text.disbursement') : $t('option.all')) }}
                </div>
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column
              prop="createMessage"
              :label="$t('text.createMessage')"
              align="center"
              width="380"/>

          <el-table-column
              prop="enabled"
              :label="$t('text.status')"
              align="center"
              width="120">
            <template slot-scope="scope">
              <el-tag
                  size="medium"
                  :type="scope.row.enabled ? (new Date(scope.row.endTime) < new Date() ? 'danger' : 'success') : 'warning'">
                {{ new Date(scope.row.endTime) < new Date() ? $t('text.timeIsUpUnlocked') : $formatter.formatRechargeEnabledType(null, null, scope.row.enabled, null) }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column
              prop="operator"
              :label="$t('text.operator')"
              align="center"
              width="100"/>

          <el-table-column
              prop="createTime"
              :label="$t('text.creationTime')"
              align="center"
              width="160"/>

          <el-table-column
              prop="endTime"
              :label="$t('text.endTime')"
              align="center"
              width="160"
              :formatter="$formatter.formatDate"/>

          <el-table-column
              prop="updateTime"
              :label="$t('text.updateTime')"
              align="center"
              width="160"/>

          <el-table-column
              prop="remark"
              :label="$t('text.remark')"
              align="center">
            <template slot-scope="{ row }">
              <template v-if="row.remark">
                <el-popover
                    placement="top-start"
                    width="300"
                    trigger="hover"
                    :content="row.remark">
                  <span slot="reference" class="truncate-text">
            {{ row.remark.length > 40 ? row.remark.slice(0, 40) + '...' : row.remark }}
            </span>
                </el-popover>
              </template>
              <span v-else></span>
            </template>
          </el-table-column>

          <el-table-column fixed="right"
                           :label="$t('text.actions')"
                           width="100"
                           align="center">
            <template slot-scope="scope">
              <el-button v-if="ROLE_TYPE.isManager()"
                         type="danger"
                         size="mini"
                         plain
                         :disabled=!scope.row.enabled
                         @click="customerCertHide(scope.row)">
                {{ $t('text.close') }}
              </el-button>
            </template>
          </el-table-column>
        </template>
      </page>
      <AddBlackList
          :isShowAddBlackListDialog.sync="isShowAddBlackListDialog"
      />
      <BlackListRiskConfig
          :isShowBlackListRiskConfigDialog.sync="isShowBlackListRiskConfigDialog"
      />
    </div>
  </div>
</template>
<script>

import Page from "@/components/Page.vue";
import loading from "element-ui/packages/loading";
import {ROLE_TYPE} from "@/utils/Constant";
import AddBlackList from "@/views/developer/AddBlackList.vue";
import BlackListRiskConfig from "@/views/developer/BlackListRiskConfig.vue";


export default {
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE
    },
    loading() {
      return loading
    }
  },
  components: {
    AddBlackList,
    BlackListRiskConfig,
    page: Page,
  },
  data() {
    return {
      url: "/blacklist/select",
      createTimeDate: null,
      showCreateBlackList: "",
      isShowAddBlackListDialog: false,
      isShowBlackListRiskConfigDialog: false,
      form: {
        customerCert: "",
        operator: "",
      },
      formRules: {
        createTimeDate: [
          {
            type: "date",
            trigger: "change",
            validator: this.validateDate
          }
        ]
      },
      moduleList: [],
    };
  },
  methods: {
    reset() {
      this.operator = "";
      this.customerCert = "";
    },
    validateDate() {
      if (!this.createTimeDate) {
        this.showCreateTimeDateError = this.$t('message.creationTimeOrFinishTimeRequiredError');
      } else {
        this.showCreateTimeDateError = "";
      }
    },
    handleShowAddBlackList() {
      this.isShowAddBlackListDialog = true;
    },
    handleShowBlackListRiskConfig() {
      this.isShowBlackListRiskConfigDialog = true;
    },
    customerCertHide(row) {
      let customerCert = row.customerCert;

      this.$confirm(
          this.$t('message.confirmDeletingCustomerCert', {customerCert: customerCert}),
          this.$t('text.prompt'),
          {
            confirmButtonText: this.$t('text.confirm'),
            cancelButtonText: this.$t('text.cancel'),
            type: "warning"
          })
          .then(() => {
            this.axios
                .put("/blacklist/hide", {customerCert: customerCert})
                .then((res) => {
                  if (res.code === 200) {
                    this.$bus.$emit("refresh"); //通知刷新
                    this.$notify({
                      title: this.$t('text.prompt'),
                      message: res.msg,
                      type: "success"
                    });
                  } else {
                    this.$notify.error({
                      title: this.$t('text.prompt'),
                      message: res.msg
                    });
                  }
                });
          })
          .catch(() => {
          });
    },
  },
  created() {
    this.reset();
  }
};
</script>